import { GlobalDesignAction } from '../types';
import { globalColorsGrouping } from './grouping';
import DefaultLobbyItem from '../common/lobby/DefaultLobbyItem';
import GlobalColorsStyles from './GlobalColorsStyles';

const globalColorsAction: GlobalDesignAction<'globalColorsStyles'> = {
  panel: GlobalColorsStyles,
  lobbyItem: DefaultLobbyItem,
  grouping: globalColorsGrouping,
};

export default globalColorsAction;
